import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UploadOrgUsersListBlockData from 'Models/Content/UploadOrgUsersListBlockData';
import OrgUsersManagement from './OrgUsersManagement';

export default class UploadOrgUsersListBlock extends EpiComponent<UploadOrgUsersListBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (
          <OrgUsersManagement iContent={this.props.data}/>
      )
    }
}
